export default "__VITE_PUBLIC_ASSET__e3ed95a7__"